module.exports = __webpack_public_path__ + "media/28-01b-fr.7d536cfa.mp4";